// this file origin from Winningtemp.Shared

import React from "react";
import PropTypes, { bool } from "prop-types";
import styled from "styled-components";
import { brandedImage } from "Helpers";

const Wrapper = styled.a`
	display: ${(props) => props.display || "block"};
	width: ${(props) => props.width || "135px"};
	height: ${(props) => props.height || "32px"};
	margin: ${(props) => props.margin || "0"};
`;

const Image = styled.img`
	border: 0;
	max-height: 100%;
	position: relative;
	object-fit: contain;
`;

const Logo = (props) => {
	return (
		<>
			<Wrapper
				href="#"
				width={props.width}
				height={props.height}
				margin={props.margin}
				display={props.display}
				onClick={(e) => e.preventDefault()}>
				<Image
					src={
						props.usePurpleLogo
							? brandedImage("/images/logo/logo-purple.png", props.customerBranding)
							: brandedImage("/images/logo/logo-white-no-padding.png", props.customerBranding)
					}
					alt="Winningtemp logo"
				/>
			</Wrapper>
		</>
	);
};

Logo.propTypes = {
	usePurpleLogo: bool,
	display: PropTypes.string,
	width: PropTypes.string,
	margin: PropTypes.string,
};

export default Logo;
